import React from 'react';
import "./underReview.scss";
import { getOfferPreFilledData } from "../../selectors";
import { connect } from "react-redux";
import YorLoanDetails from "../AddBankDetails/yourLoanDetails";
import { documentUnderReviewDataLayer, documentUploadedStatusDataLayer } from "../../analytics/adobe/pendDataLayerValues";
import { setPageNameSiteSection, updateStandardDataLayerAttributes } from "../../analytics/adobe";

export class UnderReview extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      showStatus: true
    };
  }
  componentDidMount() {
    const { pageName, siteSection }=(this.props.offerPreFilled.documentUploaded?documentUploadedStatusDataLayer:documentUnderReviewDataLayer);
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  render() {
    const documentUploaded=this.props.offerPreFilled.documentUploaded;
    return(
      <div className="row">
        <div className="col-lg-5 col-sm-12 col-xs-12 col-md-6 display-bank-details-flex padding-l-r-5">
          <div className="row">
            <YorLoanDetails showStatus={this.state.showStatus} offerPreFilled={this.props.offerPreFilled} />
          </div>
        </div>
        <div className="col-lg-7 col-sm-12 col-xs-12 col-md-6 padding-l-r-5">
          <div className="row">
            <div className="action-card">
              <div className="action-body">
                <div className="action-heading1">Your loan is under review. Check back soon!</div>
                <p>Your application is under review. There is no action required at this time.
                Log in any time to see the status of your loan application.
                When additional action are required we'll send you notifications using the email you provided.</p>
              </div>
            </div>
            {documentUploaded? <div className="action-card action-card-success">
              <div className="action-body">
                <span className="right-tick-completed"></span>
                <span className="success-msg">Documents uploaded successfully</span>
              </div>
            </div>:null}
            <div className="action-card action-card-success">
              <div className="action-body">
                <span className="right-tick-completed"></span>
                <span className="success-msg">Application submitted for a Barclays Personal Loan</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state) };
};

export default connect(mapStateToProps)(UnderReview);


